import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'

import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'

import ChartDonut from '../../../components/charts/ChartDonut'
import ChartDonutSkeleton from '../../../components/skeletons/ChartDonutSkeleton'
import { ChartColumnThemes } from '../../../components/charts/types/ChartColumn'
import { formatNumber } from '../../../utils/Helpers'
import { GET_CLIENTS } from '../../../queries/factory'

interface Bucket {
  key: string
  doc_count: number
}
const OperatingSystemTransactions = (): JSX.Element => {
  const { filters } = useContext(FactoryFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_CLIENTS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartDonutSkeleton />
  if (loading || !data) return <ChartDonutSkeleton />
  if (error) return <p>Error :(</p>
  if (!data?.aggregation?.aggregations) return <p>No data found</p>

  const labels: Array<string> = []
  const series: Array<number> = []

  data?.aggregation?.aggregations?.clients?.buckets.map((bucket: Bucket) => {
    labels.push(bucket.key)
    return series.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'payments-types'
    },
    labels,
    yaxis: {
      show: false
    },
    fill: {
      opacity: 1
    },
    legend: {
      formatter: function (seriesName: string, opts: any) {
        let total = 0
        opts.w.globals.series.map((serie: any) => {
          total += serie
        })

        return [seriesName, ' - ', formatNumber((opts.w.globals.series[opts.seriesIndex] / total) * 100, 2), '%']
      },
      width: 220,
      height: 300
    },
    plotOptions: {
      polarArea: {
        rings: {
          strokeWidth: 0
        },
        spokes: {
          strokeWidth: 0
        }
      }
    }
  }

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Transações por sistema operacional</Typography>
    <ChartDonut options={options} series={series} theme={ChartColumnThemes.red} type="polarArea" />
  </Paper>
}

export default OperatingSystemTransactions
